import React, { useEffect, useState } from 'react'
import {
  FreshContainer,
  FreshExtend,
  FreshHeader,
  FreshItem,
  FreshMobileContainer,
  FreshMobileHeader,
  FreshMobileItem,
  FreshMobileProducts,
  FreshMobileTop,
  FreshProducts,
  FreshSecondaryTitle,
  FreshTitle,
  FreshTitleBox,
} from './FreshPromotions.style'
import ProductService from '../../../../services/ProductService'
import { FreshItemPrice } from '../../ProductItem/ProductItem.style'
import Percent2 from '../../../Icons/Percent2'
import { ArrowRight } from '../../../Icons'

const FreshPromotions = props => {
  const [products, setProducts] = useState([])
  useEffect(() => {
    ProductService.getPromotions().then(data => {
      setProducts([
        data.products.products[0],
        data.products.products[1],
        data.products.products[3],
      ])
    })
  }, [])

  if (props.type === 'mobile' || props.type === 'tablet')
    return (
      <FreshMobileContainer id="freshContainer">
        <FreshMobileTop>
          <FreshMobileHeader>
            <Percent2 size="50px" />
            <FreshTitleBox>
              <FreshTitle>Fresh აქციები!</FreshTitle>
              <FreshSecondaryTitle>40%-მდე ფასდაკლებები</FreshSecondaryTitle>
            </FreshTitleBox>
          </FreshMobileHeader>
          <FreshExtend href="/promotions">
            <h2>ვრცლად</h2>
            <ArrowRight />
          </FreshExtend>
        </FreshMobileTop>
        <FreshMobileProducts>
          {products.map((product, i) => {
            if (i < 2) {
              return (
                <FreshMobileItem
                  key={product.slug}
                  href={`/product/${product.slug}`}
                >
                  <img src={product.image} alt={product.name} />
                  <FreshItemPrice
                    itemProp="offers"
                    itemScope
                    itemType="https://schema.org/Offer"
                  >
                    {product.price ? (
                      <p itemProp="price" content={product.price}>
                        {product.price}
                        <span
                          className="price-icon"
                          itemProp="priceCurrency"
                          content="GEL"
                        >
                          ₾
                        </span>
                      </p>
                    ) : (
                      <p className="out-of-stock">არ არის მარაგში</p>
                    )}
                    {product.old_price ? (
                      <span>{product.old_price}₾</span>
                    ) : null}
                  </FreshItemPrice>
                </FreshMobileItem>
              )
            }
            return null
          })}
        </FreshMobileProducts>
      </FreshMobileContainer>
    )

  return (
    <FreshContainer id="freshContainer">
      <FreshHeader>
        <Percent2 size="50px" />
        <FreshTitleBox>
          <FreshTitle>Fresh აქციები!</FreshTitle>
          <FreshSecondaryTitle>40%-მდე ფასდაკლებები</FreshSecondaryTitle>
        </FreshTitleBox>
      </FreshHeader>
      <FreshProducts>
        {products.map((product, i) => {
          if (i < 2) {
            return (
              <FreshItem href={`/product/${product.slug}`}>
                <img src={product.image} alt={product.name} />
                <FreshItemPrice
                  itemProp="offers"
                  itemScope
                  itemType="https://schema.org/Offer"
                >
                  {product.price ? (
                    <p itemProp="price" content={product.price}>
                      {product.price}
                      <span
                        className="price-icon"
                        itemProp="priceCurrency"
                        content="GEL"
                      >
                        ₾
                      </span>
                    </p>
                  ) : (
                    <p className="out-of-stock">არ არის მარაგში</p>
                  )}
                  {product.old_price ? <span>{product.old_price}₾</span> : null}
                </FreshItemPrice>
              </FreshItem>
            )
          }
          return null
        })}
      </FreshProducts>
      <FreshExtend href="/promotions">
        <h2>ვრცლად</h2>
        <ArrowRight />
      </FreshExtend>
    </FreshContainer>
  )
}

export default FreshPromotions
